import { ELECTRON_MODE, SELF_HOST_MIDDLE_URL } from "@constants";
import { snapshot } from "valtio";

import React, { useEffect, useState } from "react";

import { setMiddlewareApiUrl, store } from "@store";

import { getUrlHostname } from "@helpers/general";

import { SpinnerWrapper } from "@components/common/SpinnerWrapper";
import {
    setMachineIpAddress,
    syncStore,
} from "@components/Synchronization/store";

import { setIsNeedToAbortPayment } from "@pages/Kiosk/store";

function UdpServerWrapper({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element {
    const [waitingServerIP, setWaitingServerIP] = useState(true);

    useEffect(() => {
        const { middlewareApiUrl } = snapshot(store);
        const hostnameUrl = getUrlHostname(middlewareApiUrl);
        if (process.env.REACT_APP_MODE === ELECTRON_MODE) {
            (window as RendererWindow).electronAPI?.onUdpMessage(
                (data: { serverHostName: string; serverIpAddress: string }) => {
                    const serverHostName =
                        localStorage.getItem("serverHostName");

                    // If no server host name saved in local storage, stop processing UDP message
                    if (serverHostName === null) {
                        console.log(
                            "No server host name saved in local storage"
                        );
                        setWaitingServerIP(false);
                        return;
                    }

                    const { middlewareApiUrl } = snapshot(store);
                    const { machineIpAddress } = snapshot(syncStore);
                    const middleIpAddress = getUrlHostname(middlewareApiUrl);

                    if (data.serverHostName === serverHostName) {
                        if (data.serverIpAddress !== middleIpAddress) {
                            console.log(
                                `setting new ip address  from  old IP Address: ${middleIpAddress} with new ip address from Received UDP message: ${JSON.stringify(
                                    data
                                )}`
                            );

                            // SELF HOST KIOSK: update machine IP address
                            if (
                                machineIpAddress === middleIpAddress ||
                                SELF_HOST_MIDDLE_URL.includes(hostnameUrl)
                            ) {
                                setMachineIpAddress(data.serverIpAddress);
                            }

                            //Set Middleware new IP address
                            if (!SELF_HOST_MIDDLE_URL.includes(hostnameUrl)) {
                                setMiddlewareApiUrl(data.serverIpAddress);
                                setIsNeedToAbortPayment(true);
                            }
                        }
                        if (waitingServerIP) {
                            setWaitingServerIP(false);
                        }
                    }
                }
            );
            return;
        }
        setWaitingServerIP(false);
    }, []);

    if (process.env.REACT_APP_MODE === ELECTRON_MODE && waitingServerIP)
        return <SpinnerWrapper />;

    return <>{children}</>;
}

export default UdpServerWrapper;
